import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import * as constants from '../constants';

const initialState = {
    brand: '',
    font: '',
    color: '',
    logo: '',
    footerTxt: '',
    mainBtn: null,
    outlineBtn: null,
    backBtn: null,
    errorValidateSession: '',
};

export const getClientId = (clientId, make) => {
    // specifically check if client id is SGCM
    // SGCM can only be true for SGCM User

    if (clientId) {
        return clientId.toLowerCase();
    } else {
        return 'toyota';
    }
};

export const getBrand = theme => {
    console.log(theme);
    switch (theme.toLowerCase()) {
        case 'lfs':
            return 'lexus';
        case 'sgcm':
            return 'sgcm';
        default:
            return 'toyota';
    }
};

const loadClientStyleReducer = (state = initialState, action) => {
    switch (action.type.type) {
        case actionTypes.LOAD_CLIENT_STYLE_SUCCESS:
            return updateObject(state, constants.profile[getBrand(action.type.response.data.theme)]);

        case actionTypes.LOAD_CLIENT_STYLE_FAILED:
            return {
                ...state,
                error: action.clientId,
                errorValidateSession: action.type.error,
            };

        default: {
            return state;
        }
    }
};

export default loadClientStyleReducer;
